module.exports = __webpack_public_path__ + "static/media/ico-step5-check.9df36d4f.svg";